// Geprüfte Übersetzungen für Benachrichtigungen (Cockpit). DE = Fallback.
const notifications = {
  "Benachrichtigungen": { fr: "Notifications", it: "Notifiche", en: "Notifications" },
  "Benachrichtigung": { fr: "Notification", it: "Notifica", en: "Notification" },
  "Alle als gelesen markieren": { fr: "Tout marquer comme lu", it: "Segna tutto come letto", en: "Mark all as read" },
  "Keine Benachrichtigungen": { fr: "Aucune notification", it: "Nessuna notifica", en: "No notifications" },
  "Sie sind auf dem neusten Stand.": { fr: "Vous êtes à jour.", it: "È tutto aggiornato.", en: "You're all caught up." },
  "Neue Aufgabe": { fr: "Nouvelle tâche", it: "Nuova attività", en: "New task" },
  "Neue Antwort im Support": { fr: "Nouvelle réponse au support", it: "Nuova risposta dal supporto", en: "New support reply" },
  "Neue Rechnung": { fr: "Nouvelle facture", it: "Nuova fattura", en: "New invoice" },
  "Neues Dokument": { fr: "Nouveau document", it: "Nuovo documento", en: "New document" },
  "Monatsreport bereit": { fr: "Rapport mensuel disponible", it: "Report mensile disponibile", en: "Monthly report ready" },
  "Freigabe wartet auf Sie": { fr: "Une validation vous attend", it: "Un'approvazione ti attende", en: "An approval is waiting for you" },
};
export default notifications;
